export default __webpack_public_path__ + "static/media/bloodypactwithset.3afe615a.png";